import React from 'react';
import { Award, Users, MapIcon, TrendingUp } from 'lucide-react';

export const AboutSection = ({ t }) => {
  const stats = t.about.stats || [];
  const stat0 = stats[0] || {};
  const stat1 = stats[1] || {};
  const stat2 = stats[2] || {};
  const stat3 = stats[3] || {};

  return (
    <section id="about" className="py-20 bg-stone-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t.about.title}
          </h2>
          <p className="text-xl text-orange-500 font-semibold mb-6">
            {t.about.subtitle}
          </p>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto leading-relaxed">
            {t.about.description}
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          <div className="bg-stone-800 border border-orange-500/20 rounded-lg p-6 text-center hover:border-orange-500/50 transition-all duration-300 hover:scale-105">
            <Award className="h-10 w-10 text-orange-500 mx-auto mb-4" />
            <div className="text-4xl md:text-5xl font-bold text-orange-500 mb-2">
              {stat0.number}
            </div>
            <div className="text-sm md:text-base text-gray-300 font-medium">
              {stat0.label}
            </div>
          </div>
          
          <div className="bg-stone-800 border border-orange-500/20 rounded-lg p-6 text-center hover:border-orange-500/50 transition-all duration-300 hover:scale-105">
            <Users className="h-10 w-10 text-orange-500 mx-auto mb-4" />
            <div className="text-4xl md:text-5xl font-bold text-orange-500 mb-2">
              {stat1.number}
            </div>
            <div className="text-sm md:text-base text-gray-300 font-medium">
              {stat1.label}
            </div>
          </div>
          
          <div className="bg-stone-800 border border-orange-500/20 rounded-lg p-6 text-center hover:border-orange-500/50 transition-all duration-300 hover:scale-105">
            <MapIcon className="h-10 w-10 text-orange-500 mx-auto mb-4" />
            <div className="text-4xl md:text-5xl font-bold text-orange-500 mb-2">
              {stat2.number}
            </div>
            <div className="text-sm md:text-base text-gray-300 font-medium">
              {stat2.label}
            </div>
          </div>
          
          <div className="bg-stone-800 border border-orange-500/20 rounded-lg p-6 text-center hover:border-orange-500/50 transition-all duration-300 hover:scale-105">
            <TrendingUp className="h-10 w-10 text-orange-500 mx-auto mb-4" />
            <div className="text-4xl md:text-5xl font-bold text-orange-500 mb-2">
              {stat3.number}
            </div>
            <div className="text-sm md:text-base text-gray-300 font-medium">
              {stat3.label}
            </div>
          </div>
        </div>

        {/* Additional Content */}
        <div className="mt-16 grid md:grid-cols-2 gap-8">
          <div className="bg-stone-800 border border-orange-500/20 rounded-lg p-8">
            <img
              src="https://images.unsplash.com/photo-1571055107559-3e67626fa8be?w=600&q=80"
              alt="Chalet moderne"
              className="w-full h-64 object-cover rounded-lg mb-6"
            />
            <h3 className="text-2xl font-bold text-white mb-4">
              Nos Installations
            </h3>
            <p className="text-gray-300 leading-relaxed mb-4">
              Chalets confortables équipés de tout le nécessaire pour un séjour mémorable. Commodités modernes dans un cadre rustique authentique.
            </p>
            <p className="text-orange-500 leading-relaxed font-medium">
              Les chalets en hébergement se situent un peu partout dans les secteurs de chasse ou de plaisance. Tous entre 10 et 25 minutes de vos sites de chasse dû à l'exclusivité de tous nos territoires privés de la région.
            </p>
          </div>

          <div className="bg-stone-800 border border-orange-500/20 rounded-lg p-8">
            <img
              src="https://images.unsplash.com/photo-1762626472803-74acd75c1e8b?w=600&q=80"
              alt="Forêt d'érables"
              className="w-full h-64 object-cover rounded-lg mb-6"
            />
            <h3 className="text-2xl font-bold text-white mb-4">
              Notre Territoire
            </h3>
            <p className="text-gray-300 leading-relaxed">
              Accès à plusieurs terres privées exclusives de 100 à 500 acres, ainsi qu'à plus de 30 000 acres de territoire libre. Magnifiques forêts d'érables et de chênes. Population abondante de gibier et environnement préservé.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
